import React from "react";
import Divider from "../../../../../components/shared/Divider/Divider";

export const ReportPageFooter = ({
  club,
  date,
  page,
  totalPages,
  userName,
}) => {
  return (
    <div className="mt-auto">
      {/* Divider line */}
      <Divider className="mb-3" color="gray200" type="horizontal" />

      {/* Footer content */}
      <div className="font-manrope flex justify-between">
        <div className="flex gap-5">
          <div className="text-xs text-black">{userName}</div>
          <div className="text-xs text-black">Date: {date}</div>
          <div className="text-xs text-black">Club: {club}</div>
        </div>

        <div className="text-grayTrue500 text-[10px]">
          Page {page} of {totalPages}
        </div>
      </div>
    </div>
  );
};
